import React, { useEffect, useState, useMemo } from 'react';
import '../interceptors/axios';

import { useAuth } from "../hooks/useAuth";
import { toast, ToastContainer } from 'react-custom-alert';

// Hooks
import { useFormData } from '../hooks/useFormData';
import { useRelevamiento } from '../hooks/useRelevamiento';
import { useIsMobile } from '../hooks/useIsMobile';

// Componentes
import FormSelectOptions from '../components/FormSelectOptions';
import NavBar from "../components/NavBar";
import ConfirmModal from "../components/ConfirmModal";
import PreviewImgsNew from '../components/PreviewImgs';
import ModalOfertas from "../components/ModalOfertas";

import { useNetworkStatus } from "../hooks/useNetworkStatus";
import { OfflineBanner } from "../components/utils/OfflineBanner";

// Estilos
import '../css/ImageUploader.css';
import '../css/Form.css';
import 'react-custom-alert/dist/index.css';

import logo from "../img/login-logo.png";
import logoRitelia from "../img/logo_ritelia_fondoN.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileImage } from "@fortawesome/free-solid-svg-icons";

const BENCHMARK_MODE = false; // TODO: reemplazar con variable de entorno

/** null si ya se puede guardar; si no, texto para el botón (misma heurística que antes en la barra). */
function getLabelMientrasProcesanFotos(images) {
    const finishedInference = images.filter(
        (img) => img.imgStatus === 'done' || img.imgStatus === 'error' || img.imgStatus === 'sinDatos'
    );
    const total = images.length;
    if (total === 0 || finishedInference.length === total) return null;

    const uploadProgressSum = images.reduce((acc, img) => acc + (img.progress || 0), 0);
    const averageUploadProgress = uploadProgressSum / total;
    const firstFivePercent = averageUploadProgress * 0.05;
    const completedInferenceRatio = (finishedInference.length / total) * 95;
    const totalProgress = Math.round(firstFivePercent + completedInferenceRatio);

    return totalProgress <= 5 ? 'Subiendo archivos...' : 'Procesando...';
}

export const Form = () => {
    const isOnline = useNetworkStatus();
    const { logout } = useAuth();
    const [misProductos, setMisProductos] = useState(false);
    const [secondSelection, setType] = useState(false);
    const [initialized, setInitialized] = useState(false);
    const [isGuardando, setIsGuardando] = useState(false);

    const {
        usernameStr,
        categoryList,
        tiendaList,
        tienda, setTienda,
        category, setCategory,
        gondolaEnabled,
        etiquetaEnabled,
        loading
    } = useFormData();

    const isMobile = useIsMobile();

    // 1. Sincronización inicial de permisos
    useEffect(() => {
        if (!loading && !initialized) {
            if (gondolaEnabled && !etiquetaEnabled) {
                setMisProductos(true);
            } else {
                setMisProductos(false);
            }
            setInitialized(true);
        }
        if (!isOnline && isGuardando) {
            // Se cortó internet mientras guardaba
            setIsGuardando(false);
            toast.error("Perdiste conexión durante el guardado. Revisá tus fotos y volvé a intentar.");
        }
    }, [loading, gondolaEnabled, etiquetaEnabled, initialized]);

    const {
        idRelevamiento,
        imagesData,
        showBotonGuardar,
        dataSKU,
        dataOfertas,
        isModalOpen, setIsModalOpen,
        isModalOfertasOpen,
        handleCargarFotos,
        handleEliminarFoto,
        handleGuardar,
        handleSubmit,
        relevamientoAprobado,
    } = useRelevamiento({ category, misProductos, tienda, isOnline });

    const styles = {
        input: {
            width: '100%',
            fontWeight: '600',
            padding: '10px 10px 10px 20px',
            borderRadius: '10px',
            border: '1px solid #ccc',
            outline: 'none',
            fontFamily: 'Nunito Sans'
        }
    };

    // 2. MEMOIZACIÓN DEL FORMULARIO
    // Esto evita que los Dropdowns se desmonten y reboten a "false"
    const memoizedFormFields = useMemo(() => {
        const labelPendienteFotos = getLabelMientrasProcesanFotos(imagesData);
        const guardarActivoVisual = isOnline && !labelPendienteFotos;

        return (
            <div className="justify-content-md-center">
                <div className="col-12" style={{ textAlign: 'center' }}>

                    <div><img
                        style={{ width: '30%', marginBottom: 20 }}
                        src={logo}
                        alt="logo"
                    /></div>
                    <div style={{marginBottom:'30px'}}><img
                        src={logoRitelia}
                        alt={"Ritelia"}
                        /></div>
                    <FormSelectOptions
                        tiendas={tiendaList}
                        setTiendas={setTienda}
                        category={category}
                        categoryList={categoryList}
                        setCategory={setCategory}
                        setType={setType}
                        setMisProductos={setMisProductos}
                        misProductos={misProductos}
                        relevamientoIniciado={showBotonGuardar}
                        gondolaEnabled={gondolaEnabled}
                        etiquetaEnabled={etiquetaEnabled}
                    />
                </div>

                <div className="col-12">
                    <div className="upload-container">
                        {isOnline && (
                            <div
                                style={{
                                    width: '100%',
                                    borderBottom: showBotonGuardar ? '1px solid #DDD' : 'none',
                                }}
                            >
                                <input
                                    name="fotos"
                                    id="fotos"
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    style={styles.input}
                                    onChange={(e) => handleCargarFotos(e, tienda, BENCHMARK_MODE)}
                                    onClick={(e) => {
                                        if (!isOnline) {
                                            e.preventDefault();
                                            return;
                                        }
                                        e.target.value = null;
                                    }}
                                    hidden
                                />
                                <label
                                    className="label-fotos-original"
                                    style={{
                                        width: '100%',
                                        backgroundColor: isOnline ? '#2C2D5B' : '#A0A0A0',
                                        color: 'white',
                                        padding: '12px',
                                        borderRadius: '10px',
                                        cursor: isOnline ? 'pointer' : 'not-allowed',
                                        display: 'block',
                                        fontWeight: 600,
                                        opacity: isOnline ? 1 : 0.6,
                                        transition: 'background-color 0.3s, opacity 0.3s',
                                        textAlign: 'center',
                                    }}
                                    htmlFor={isOnline ? 'fotos' : undefined}
                                >
                                    <FontAwesomeIcon
                                        icon={faFileImage}
                                        style={{ marginRight: 10 }}
                                    />
                                    {idRelevamiento === -1 ? 'Cargar fotos' : 'Cargar más fotos'}
                                </label>
                            </div>
                        )}

                        {isMobile && (
                            <PreviewImgsNew
                                imagesData={imagesData}
                                onDeleteImage={handleEliminarFoto}
                            />
                        )}

                        <div style={{ width: '100%' }}>
                            {showBotonGuardar && (
                                <button
                                    className="btn-guardar-estilo"
                                    style={{
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        backgroundColor: guardarActivoVisual ? '#21BDA2' : '#A0A0A0',
                                        width: '100%',
                                        marginTop: '20px',
                                        padding: '12px',
                                        border: 'none',
                                        borderRadius: '10px',
                                        fontWeight: 'bold',
                                        color: '#1F1F39',
                                        cursor: guardarActivoVisual ? 'pointer' : 'not-allowed',
                                        opacity: guardarActivoVisual ? 1 : 0.6,
                                        transition: 'background-color 0.3s, opacity 0.3s',
                                    }}
                                    onClick={handleGuardar}
                                    type="submit"
                                    disabled={!isOnline || labelPendienteFotos}
                                    title={
                                        !isOnline
                                            ? 'Sin conexión a internet'
                                            : labelPendienteFotos
                                              ? 'Esperá a que terminen de subirse y procesarse las fotos'
                                              : ''
                                    }
                                >
                                    {!isOnline
                                        ? 'Sin conexión...'
                                        : labelPendienteFotos || 'Guardar'}
                                </button>
                            )}

                            {showBotonGuardar && (
                                <button
                                    className="cancelarbtn"
                                    style={{
                                        fontFamily: 'Nunito Sans, sans-serif',
                                        backgroundColor: '#FFF',
                                        width: '100%',
                                        marginTop: '10px',
                                        borderRadius: '10px',
                                        border: '1px solid #C9CDD2',
                                        padding: '12px',
                                        fontWeight: 'bold',
                                        color: '#212529',
                                    }}
                                    type="button"
                                    onClick={() => window.location.reload()}
                                >
                                    Cancelar
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }, [
        tiendaList, category, categoryList, misProductos, showBotonGuardar, tienda,
        imagesData, isMobile, gondolaEnabled, etiquetaEnabled, idRelevamiento, isOnline
    ]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
                <img src={logo} style={{ width: '80px' }} alt="Cargando..." />
            </div>
        );
    }

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh',
            }}
        >
            <OfflineBanner />
            <NavBar username={usernameStr} logout={logout} />

            {/* Área que ocupa todo el alto restante (flex: 1) y centra la card */}
            <div
                style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '20px',
                }}
            >
                {isMobile ? (
                    <div
                        style={{
                            width: '100%',
                            maxWidth: '560px',
                            padding: '24px',
                            fontFamily: 'Nunito Sans, sans-serif',
                            backgroundColor: '#FFF',
                            borderRadius: '30px',
                            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                        }}
                    >
                        {memoizedFormFields}
                    </div>
                ) : (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'flex-start',
                            gap: '40px',
                            width: '100%',
                            maxWidth: '1200px',
                        }}
                    >
                        <div
                            style={{
                                flex: '0 0 320px',
                                padding: '24px',
                                fontFamily: 'Nunito Sans, sans-serif',
                                backgroundColor: '#FFF',
                                borderRadius: '30px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                            }}
                        >
                            {memoizedFormFields}
                        </div>

                        <div
                            style={{
                                flex: 1,
                                padding: '25px',
                                borderRadius: '8px',
                                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
                                minHeight: '600px',
                                height: 'calc(100vh - 140px)',
                            }}
                        >
                            {imagesData.length > 0 ? (
                                <PreviewImgsNew
                                    imagesData={imagesData}
                                    onDeleteImage={handleEliminarFoto}
                                />
                            ) : (
                                <div style={{ textAlign: 'center', color: '#CCC', marginTop: '150px' }}>
                                    <FontAwesomeIcon icon={faFileImage} size="4x" style={{ marginBottom: '20px', opacity: 0.2 }} />
                                    <p>Aquí verás las fotos una vez que las selecciones.</p>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>

            <ConfirmModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                onConfirm={handleSubmit}
                dataSKU={dataSKU}
                dataOfertas={dataSKU["ofertas"]}
            />
            <ModalOfertas
                isOpen={isModalOfertasOpen}
                onClose={() => relevamientoAprobado()}
                dataOfertas={dataOfertas}
            />
            <ToastContainer floatingTime={2000} />
        </div>
    );
};
